import { motion } from "framer-motion";
import { fadeUp, slideRight, slideLeft } from "../../animations/variants";
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const HeroService = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToSection = (id) => {
    if (location.pathname !== "/") {
      navigate("/" + id);
      return;
    }
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative overflow-hidden mt-[0px] pt-[80px] md:h-[calc(100vh-80px)]">
      {" "}
      <div
        className="absolute inset-0 md:hidden"
        style={{
          backgroundImage: `url("/maria/maria3.png")`,
          backgroundSize: "90% auto",
          backgroundPosition: "300% 100%",
          backgroundRepeat: "no-repeat",
        }}
      />
      <div className="absolute inset-0 bg-white/60 md:hidden" />
      <div className="relative flex flex-col lg:items-center justify-center item-start lg:py-20 lg:px-6 px-0 py-20">
        {" "}
        <div className="max-w-7xl ml-10 lg:mx-auto  grid md:grid-cols-2 gap-10 items-center">
          <motion.div
            variants={slideLeft}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            className="min-h-[300px]"
          >
            <motion.div
              variants={fadeUp}
              className="mt-40 lg:text-center text-left font-[Crimson] "
            >
              {" "}
              <h1 className="text-5xl md:text-7xl lg:text-8xl font-extrabold -tracking-[0.2rem] lg:-tracking-[0.5rem] text-reddark uppercase">
                Services
              </h1>
              <p className="mt-3 text-2xl md:text-4xl text-gray-800">
                with{" "}
                <span className="font-medium tracking-wide tracking-widest">
                  Maria Pooley
                </span>
              </p>
            </motion.div>
          </motion.div>

          <motion.div
            variants={slideRight}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
            className="hidden md:block max-w-[500px] flex justify-center border border-reddark rounded-xl pt-10 px-10 pb-0"
          >
            <motion.img
              src="/maria/maria3.png"
              alt="Maria Advisory"
              className="w-full h-auto object-contain bg-gray-200 rounded-t-xl "
              initial={{ opacity: 0, x: 40 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 1 }}
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default HeroService;
